import axios from "axios";
import config from "../constants/config";
import { normalize } from "normalizr";

export function GET(payload) {
    return submit(payload.url, "get", null, payload.locale, payload.schema);
}

export function POST(payload) {
    return submit(
        payload.url,
        "post",
        payload.data,
        payload.locale,
        payload.schema
    );
}

export function PUT(payload) {
    return submit(
        payload.url,
        "put",
        payload.data,
        payload.locale,
        payload.schema
    );
}

export function DELETE(payload) {
    return submit(payload.url, "delete", null, payload.locale, payload.schema);
}

function submit(url, method, data = null, locale = "en", schema = null) {
    return new Promise((resolve, reject) => {
        let headers = { "Accept-Language": locale };

        let origin = window.location.origin;

        if (data && data instanceof FormData) {
            headers["Content-Type"] = "multipart/form-data";
        }
        axios({
            url: origin + "/" + url,
            method,
            data,
            timeout: config.TIMEOUT,
            headers,
        })
            .then((response) => {
                if (response.status === 204) {
                    resolve(null);
                } else {
                    if (schema) resolve(normalize(response.data, schema));
                    else resolve(response.data);
                }
            })
            .catch((error) => {
                if (error.response) {
                    reject({
                        status: error.response.status,
                        data: error.response.data,
                        message: null,
                    });
                } else if (error.request) {
                    reject({
                        status: null,
                        data: null,
                        message: null,
                    });
                } else {
                    reject({
                        status: null,
                        data: null,
                        message: error.message,
                    });
                }
            });
    });
}
